import axios from 'axios'
import { BUSCAR_FECHAMENTO_DIA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default idEmpresa => dispatch => axios.get(`${URL}/fechamento-caixa-usuario/empresa/${idEmpresa}/fechamento-dia`,SLOW_REQUEST_CONFIG)
  .then(response => dispatch({
    type: BUSCAR_FECHAMENTO_DIA,
    payload: response
  }));
